import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-rose-50 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-rose-500">
              <i className="ri-heart-pulse-fill text-white text-sm"></i>
            </div>
            <span
              className="font-bold text-base text-gray-800"
              style={{ fontFamily: "Pacifico, cursive" }}
            >
              LoveNavi
            </span>
          </div>
          <p className="text-gray-500 text-xs leading-relaxed">
            あなたにぴったりの出会いアプリを見つけよう
          </p>
        </div>

        <div className="border-t border-rose-100 pt-5">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-gray-400 mb-4">
            <Link to="/privacy" className="hover:text-rose-500 transition-colors cursor-pointer">
              プライバシーポリシー
            </Link>
            <Link to="/terms" className="hover:text-rose-500 transition-colors cursor-pointer">
              利用規約
            </Link>
            <Link to="/company" className="hover:text-rose-500 transition-colors cursor-pointer">
              運営会社
            </Link>
          </div>
          <div className="text-center text-[10px] text-gray-400">
            <p>&copy; 2025 LoveNavi All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
